import store from '../store';
import axios from 'axios';
import router from "../router";

export default {
  name: 'groupsPlaceApi',

  checkMaintenance() {
    if (store.state.settings && store.state.settings.maintenanceMode) {
      window.location = "/maintenance"
      return true
    }
    return false
  },

  genHeader() {
    //we might get here before the setters are done!
    let apiKey = localStorage.getItem("apiKey")
    let secret = localStorage.getItem("secret")
    return {
      headers: {
        'ApiKey': apiKey, 'SecretKey': secret,
        'ui_version': process.env.BUILD_VERSION,
        'isStandalone': this.isStandalone()
      },
      withCredentials: true
    };
  },
  async groupBasics(vanityPath, mode) {
    if (this.checkMaintenance()) return
    let current = store.getters.currentGroup;
    if (!current || current.vanityPath != vanityPath) {
      await axios.get(process.env.BACKEND_URL + "/api/v1/group/info/" + vanityPath + "?mode=" + mode, this.genHeader()).then(
        response => {
          store.dispatch("setCurrentGroup", response.data);
        },
        error => {
          store.dispatch("setCurrentGroup", null);
        }
      );
    }
  },
  async waitGet(path) {
    let ret;
    await axios.get(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader()).then(
      response => {
        ret = response;
      },
      error => {
        if (error.response.status == 401) {
          store.dispatch("logout");
          ret = error.response;
        } else ret = error.response;
      }
    );
    return ret;
  },
  get(path) {
    if (path != "/public/settings" && this.checkMaintenance()) return
    return axios.get(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader());
  },
  getExternalBlob(path) {
    if (this.checkMaintenance()) return
    return axios.get(path);
  },
  getBlob(path) {
    if (this.checkMaintenance()) return
    let h = this.genHeader();
    h.responseType = "blob";
    return axios.get(process.env.BACKEND_URL + "/api/v1" + path, h);
  },
  postBlob(path, data) {
    if (this.checkMaintenance()) return
    let h = this.genHeader();
    h.responseType = "blob";
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, data, h);
  },
  reloadUser() {
    axios.get(process.env.BACKEND_URL + "/api/v1/user/details", this.genHeader()).then(
      (details) => {
        store.dispatch("setUserDetails", details.data);
      },
      (error) => {
        console.log("Error getting user details again.");
      });

  },
  post(path, data) {
    if (this.checkMaintenance()) return
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, data, this.genHeader());
  },
  put(path, data) {
    if (this.checkMaintenance()) return
    return axios.put(process.env.BACKEND_URL + "/api/v1" + path, data, this.genHeader());
  },
  postImage(path, file) {
    if (this.checkMaintenance()) return
    return this.postFile(path, file);
  },
  postFile(path, file) {
    if (this.checkMaintenance()) return
    let formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    let headers = this.genHeader;
    headers['Content-Type'] = 'multipart/form-data';
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, formData, this.genHeader());
  },
  async getGroupFileLink(fileId, accessCode) {
    let downloadInfo
    await axios.get(process.env.BACKEND_URL + `/api/v1/groupFile/getDownloadLink/${fileId}?accessCode=${accessCode}`, this.genHeader()).then(
      response => {
        downloadInfo = response.data
      });
    return downloadInfo
  },

  async generalUploadImage(folder, group, file) {
    let ret = {s3Response: null, message: "", success: true, image: null}
    let forUser = true
    if (group || folder) forUser = false
    let payload = {
      isUrlRequest: true,
      forUser: forUser,
      folder: folder,
      group: group,
      filename: file.name,
      size: file.size,
      type: file.type
    }
    await this.post("/image/create", payload).then(
      (results) => {
        ret.uploadRequest = results.data
      },
      (error) => {
        ret.success = false
        ret.message = error.response.data
      })

    if (!ret.success) return ret

    const response = await fetch(ret.uploadRequest.url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      },
    })
    ret.s3Response = response
    if (!response.ok) {
      ret.message = await response.text()
      ret.success = false
    }
    payload = {
      isUrlRequest: false, folder: folder, group: group, filename: file.name,
      size: file.size, type: file.type, uploadRequestId: ret.uploadRequest.id
    }
    await this.post("/image/create", payload).then(
      (results) => {
        ret.image = results.data.image
      },
      (error) => {
        ret.success = false
        ret.message = error.response.data
      })

    return ret
  },

  async groupUploadImage(groupId, file) {
    let ret = {uploadRequest: null, s3Response: null, message: "", success: true}

    let payload = {filename: file.name, size: file.size, type: file.type}
    await this.post("/group/imageUploadRequest/" + groupId, payload).then(
      (results) => {
        ret.uploadRequest = results.data
      },
      (error) => {
        ret.success = false
        ret.message = error.response.data
      })

    if (!ret.success) return ret

    const response = await fetch(ret.uploadRequest.url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      },
    })
    ret.s3Response = response
    if (!response.ok) {
      ret.message = await response.text()
      ret.success = false
    }
    return ret

  },

  delete(path) {
    if (this.checkMaintenance()) return
    return axios.delete(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader());
  },
  async getUserDetails() {
    await axios.get(process.env.BACKEND_URL + "/api/v1/user/details", this.genHeader()).then(
      response => {
        store.dispatch("setUserDetails", response.data);
      },
      error => {
        if (error.response.status == 403 && document.location.href.indexOf("/login/oauth2") < 0) {  //Don't log out if cognito login is in process
          store.dispatch("loggedIn", false)
          store.dispatch("logout")
        }
      }
    );
  },
  async completeLogin(auth, secret, isNewUser) {
    localStorage.setItem("apiKey", auth)
    localStorage.setItem("secret", secret)
    await store.dispatch("setApiKey", auth)
    await store.dispatch("setSecret", secret)
    await store.dispatch("setLoggedIn", true)
    await this.getUserDetails()
    if (this.isStandalone()) {
      await this.checkPush()
    }
    let redirect = localStorage.getItem("redirectOnLogin")
    if (redirect) {
      localStorage.removeItem("redirectOnLogin")
      router.push(redirect)
    } else if (isNewUser) router.push("/new-user")
    else router.push("/")
  },
  async checkPush() {
    let disabled = localStorage.getItem("nopush")
    if (disabled == "true") {
      console.log("Push was previously removed.")
      return
    }
    if (navigator && navigator.serviceWorker) {
      const registration = await navigator.serviceWorker.ready;
      const existingSubscription = await registration.pushManager.getSubscription();
      if (!existingSubscription && this.isStandalone()) {
        await this.subscribePush()
      }
    }
  },
  trackGroupVisit(vanityPath) {
    if (this.checkMaintenance()) return
    this.post("/member/trackVisit/" + vanityPath, {}).then(
      () => {

      },
      error => {
        console.log("Got error tracking last visit.", error)
      }
    );
  },
  isStandalone() {
    if ('standalone' in window.navigator) {
      return window.navigator.standalone;
    } else {
      // Check for other indicators
      if (window.matchMedia('(display-mode: standalone)').matches) {
        return true;
      } else {
        return false;
      }
    }
  },
  urlB64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  },
  async subscribePush() {
    let ret = {success: true, message: ""}
    await navigator.serviceWorker.ready
      .then(async (swReg) => {
        let registration = swReg; // Get the service worker registration
        const applicationServerPublicKey = "BBWTVOl0VoNSumJ0a3W6fNl6233FDXc5PHNCyLH6V2IR3hr7lYcnvbiehKetO3JecGrGrqT2ruC3ICkyTVHq-zc"
        let applicationServerKey = this.urlB64ToUint8Array(applicationServerPublicKey);
        await registration.pushManager.subscribe({
                                             userVisibleOnly: true,
                                             applicationServerKey: applicationServerKey
                                           })
          .then(async (subscription) => {
            await this.updateSubscriptionOnServer(subscription).then( () => {
              console.log("Subscription complete.")
            })
          })
          .catch((err) => {
            console.error(err.message, err.code, err.name)
            ret.success = false
            ret.message = err.message
          });
      })
      .catch((error) => {
        console.error("GP-ERR-200: Service worker registration failed: ", error);
        ret.success = false
        ret.message = error.message
      });
    return ret
  },
  async updateSubscriptionOnServer(subscription) {
    let payload = JSON.parse(JSON.stringify(subscription))
    await this.post("/notification/addPush/" , payload).then( () => {
      console.log("Added push.")
    })
  },

  trackEvent(eventName, payload) {
    if (typeof smartlook == "function" ) {
      smartlook("track", eventName, payload)
    }
  }


  };
